import _ from 'lodash';
import { connect } from 'react-redux';
import { showErrors } from '../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	const permissions = _.get(state.auth.authUser, ['permissions'], []);
	const isAdmin = _.includes(permissions, 'isAdmin');
	const accessToken = _.get(state.auth, 'accessToken');
	const accessIsForMobile = _.get(state.auth, 'accessIsForMobile');
	const permissionMap = permissions ? _.keyBy(permissions) : {};

	return {
		authUser: state.auth.authUser,
		permissions,
		permissionMap,
		accessToken,
		accessIsForMobile,
		isAdmin,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
